import { IBusiness, isIBusiness } from '@/coreDomainsModule/entities/businessBase';
import { OrderControlHeaderKey, TableContentHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { convertIDateToDateFormat } from '../../utils/dateFormat';
import { AlertType } from '@/coreDomainsModule/entities/hasRecommendOrders';
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';
import { IOrderControl } from '@/orderControlModule/entities/IOrderControl';
import { convertLeadTimeByUnit } from '@/coreDomainsModule/leadtime';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountService } from '@/coreDomainsModule/services/userAccountService';

// i18n
const t = i18n.t;

/**
 *　発注周りのテーブル表示に使うロジック
 */
export class OrderControlTableContentViewModel extends BaseTableContentViewModel {
  /**
   * 発注の項目表示用
   * @param headerKey - ヘッダーキー
   * @param item - テーブルコンテンツアイテム
   */
  public displayOrderItem = (headerKey: OrderControlHeaderKey, item: TableContentItem): string => {
    const business = item as IOrderControl & { lastCheckedAt?: Date }; // こいつは、IBusinessを要求しているので、ここで判定（ある前提なのでthrowErrorしてもいいかも）
    switch (headerKey) {
      case 'OrderControlOrderStatus':
        return business?.orderStatus?.toString() ?? '--';
      case 'OrderControlOrderDate':
        const createOrderDate = business?.createdOrderDate;
        if (!createOrderDate || createOrderDate < 0) return '--'; // 推奨発注の場合：表示する意味がないので"-"で
        return convertIDateToDateFormat(DateService.convertUnixTimeToIDate(createOrderDate));
      case 'OrderControlLastCheckedAt':
        if (!business?.lastCheckedAt || Number.isNaN(business.lastCheckedAt.getTime())) {
          return '--';
        }
        return DateService.convertDateToYYYYMMDDHHMM(business.lastCheckedAt);
      case 'OrderControlOrderAmount':
        return business?.orderAmount?.addComma() ?? '';
      case 'OrderControlDeliveryDate':
        if (!business?.desiredDeliveryDate) return '';
        return convertIDateToDateFormat(DateService.convertUnixTimeToIDate(business?.desiredDeliveryDate));
      case 'OrderControlWarehouseNumber':
        return business?.warehouseNumber?.toString() ?? '--';
      case 'OrderControlWarehouse':
        return business?.warehouse?.toString() ?? '--';
      case 'OrderControlSupplierNumber':
        return business?.supplierNumber?.toString() ?? '--';
      case 'OrderControlSupplierName':
        return business?.supplierName?.toString() ?? '--';
      case 'OrderControlBusinessNumber':
        return business?.businessNumber?.toString() ?? '--';
      case 'OrderControlBusinessName':
        return business?.businessName?.toString() ?? '--';
      case 'OrderControlPackage':
        return business?.package?.toString() ?? '--';
      case 'OrderControlUnit':
        return business?.unit?.toString() ?? '--';
      case 'OrderControlManufacturer':
        return business?.manufacturer ?? '--';
      case 'OrderControlCustomerName':
        return '--';
      case 'OrderControlSalesDestinationName':
        return '--';
      case 'OrderControlLeadTime':
        return `${convertLeadTimeByUnit(business?.leadTime ?? 0, business?.leadTimeUnit ?? '')}${t(business?.leadTimeUnit ?? '')}`;
      case 'OrderControlStdInventoryIndex':
        return `${business?.stdInventoryIndicesMin ?? ''}~${business?.stdInventoryIndicesMax ?? ''}${t(
          business?.stdInventoryIndicesUnit ?? ''
        )}`;
      case 'OrderControlPurchaseUnitPrice':
        return business?.purchaseUnitPrice?.addComma() ?? '--';
      case 'OrderControlAggregateBusinessResponsibleUsers':
        console.log(item?.aggregateBusinessResponsibleUsers);
        if (!item?.aggregateBusinessResponsibleUsers || item.aggregateBusinessResponsibleUsers.length === 0) return '--';
        return (
          item.aggregateBusinessResponsibleUsers.map((user: UserAccount) => UserAccountService.getDisplayName(user)).join(', ') ?? '--'
        );
      default:
        return ''; // 未対応のヘッダーキーは空文字列を返す
    }
  };
}
